class NewsletterPopup extends ModalDialog {
  constructor() {
    super();
    this.init();
    this.attachEventListeners();
  }

  attachEventListeners() {
    this.querySelectorAll(".js-button-close").forEach((button) => {
      button.addEventListener("click", this.closeNewsletter.bind(this));
    });
  }

  init() {
    this.delay = this.dataset.delay * 1000;
    this.closed = getCookie("newsletter-closed");
    this.subscribed = getCookie("newsletter-subscribed");
    this.justSubscribed = Boolean(this.querySelector("[data-newsletter-subscribed]"));
    this.hasFormError = Boolean(this.querySelector(".newsletter__field.has-error"));
    this.ageVerificationPopup = document.querySelector("age-verification-popup");
  }

  closeNewsletter() {
    this.hide();
  }

  hide() {
    const wasOpen = this.hasAttribute("open");

    if (wasOpen && !window.Shopify?.designMode) {
      setCookie("newsletter-closed", "true");
    }

    super.hide();
  }

  connectedCallback() {
    if (Shopify.designMode) {
      if (this.dataset.openInDesignMode === "true") {
        this.show();
      }
      return;
    }

    if (this.justSubscribed) {
      const closeLabel = this.dataset.closeLabel;

      if (closeLabel) {
        this.querySelectorAll(".newsletter-popup__dismiss").forEach((button) => {
          button.textContent = closeLabel;
        });
      }

      setCookie("newsletter-subscribed", "true");
      this.show();
      return;
    }

    if (this.hasFormError) {
      this.show();
      return;
    }

    this.handlePopupVisibility();
  }

  handlePopupVisibility() {
    if (getCookie("age-verified") !== "true" && this.ageVerificationPopup) {
      this.handleAgeVerificationPopup();
    } else {
      this.showPopupWithDelay();
    }
  }

  handleAgeVerificationPopup() {
    let prevClassState = this.classList.contains("newsletter-popup-is-hidden");

    const observer = new MutationObserver(mutations => {
      const mutation = mutations[0];
      if (mutation.attributeName !== "class") return;

      const currentClassState = mutation.target.classList.contains("newsletter-popup-is-hidden");

      if (prevClassState !== currentClassState) {
        prevClassState = currentClassState;
        if (!currentClassState) {
          this.showPopupWithDelay();
        }
      }
    });

    observer.observe(this, { attributes: true });
  }

  showPopupWithDelay() {
    setTimeout(() => {
      if (this.closed !== "true" && this.subscribed !== "true") {
        this.show();
      }
    }, this.delay);
  }

}

customElements.define("newsletter-popup", NewsletterPopup);
